import type { HttpClient } from '../http/types';
import type { BackendArea } from '../types/area';
import { ENDPOINTS } from './endpoints';

export function createAreasApi(http: HttpClient) {
  return {
    list: () => http.get<BackendArea[]>(ENDPOINTS.areas.root),

    create: (departmentId: string, name: string) =>
      http.post<BackendArea>(ENDPOINTS.areas.root, { departmentId, name }),

    rename: (id: string, name: string) =>
      http.patch<BackendArea>(ENDPOINTS.areas.byId(id), { name }),

    deactivate: (id: string) => http.post<BackendArea>(ENDPOINTS.areas.deactivate(id)),
  };
}

export type AreasApi = ReturnType<typeof createAreasApi>;
